import React from 'react';

const PrevButton = (props) => {
  return (
    <button
      type="button"
      className="form-wizard-action btn btn-dark"
      {...props}
    >
      <i className="fas fa-chevron-circle-left fs-4 me-2"/>
      Previous
    </button>
  )
}

export default PrevButton